(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pernoire-discovery-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll('.pernoire-discovery-tabs');
    if (!roots.length) return;

    roots.forEach((root) => {
      const headingEl   = root.querySelector('.pdt-heading');
      const priceEl     = root.querySelector('[data-pdt-price]');
      const pills       = Array.from(root.querySelectorAll('[data-pdt-pill]'));
      const panels      = Array.from(root.querySelectorAll('[data-pdt-panel]'));
      const baseHeading = headingEl ? headingEl.textContent.trim() : '';

      function showPanel(key) {
        pills.forEach(p => {
          const active = p.dataset.pdtPill === key;
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(panel => { panel.hidden = panel.dataset.pdtPanel !== key; });

        if (!headingEl) return;
        if (key === 'all') {
          headingEl.textContent = baseHeading;
          if (priceEl) { priceEl.textContent = 'CHF 48.00'; priceEl.style.display = 'block'; }
          return;
        }

        const pill = pills.find(p => p.dataset.pdtPill === key);
        const tabName  = pill ? pill.textContent.trim() : '';
        const tabPrice = pill ? pill.dataset.price || '' : '';

        headingEl.textContent = `${baseHeading} ${tabName.toUpperCase()}`;
        if (priceEl) {
          if (tabPrice) {
            priceEl.textContent = tabPrice;
            priceEl.style.display = '';
          } else {
            priceEl.textContent = '';
            priceEl.style.display = 'block';
          }
        }
      }

      showPanel('all');
      pills.forEach(pill => pill.addEventListener('click', () => showPanel(pill.dataset.pdtPill)));

      // Add to cart for Buy Now buttons
      root.addEventListener('click', async (e) => {
        const btn = e.target.closest('.js-add-one');
        if (!btn) return;

        e.preventDefault();

        const id = Number(btn.getAttribute('data-variant-id'));
        const qty = Number(btn.getAttribute('data-qty') || '1') || 1;
        if (!id) return;

        btn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: qty }] })
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Could not add to cart');
          }

          // Many themes listen for this to open/refresh the cart drawer
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          // Or redirect:
          // window.location.href = '/cart';
        } catch (err) {
          alert(err.message);
        } finally {
          btn.disabled = false;
        }
      });
    });
  });



  document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.classList.contains('pprod-form')) return;

    // Prevent page navigation
    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const fd = new FormData(form); // contains id + Shopify hidden fields
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' }
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart');
      }

      // Notify theme to refresh/open cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Or redirect to cart if your theme does not listen:
       window.location.href = '/cart';
    } catch (err) {
      alert(err.message);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });
});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pernoire-product-top"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pernoire-product-top').forEach(function (root) {
      if (!root) return;

      /* Gallery thumbs */
      const thumbs = root.querySelectorAll('[data-pprod-thumbs] .pprod-thumb');
      const slides = root.querySelectorAll('[data-pprod-main] .pprod-main-slide');
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const id = btn.getAttribute('data-media-id');
          thumbs.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          slides.forEach(function (slide) {
            slide.classList.toggle('is-active', slide.id === id);
          });
        });
      });

      /* Variants */
      const variantsJsonEl = root.querySelector('[data-pprod-variants-json]');
      let variants = [];
      if (variantsJsonEl) {
        try {
          variants = JSON.parse(variantsJsonEl.textContent || '[]');
        } catch (e) {
          console.error('Failed to parse variants JSON', e);
        }
      }

      const variantIdInput = root.querySelector('[data-pprod-variant-id]');
      const optionBlocks = root.querySelectorAll('[data-pprod-variants] .pprod-option');

      function getCurrentOptions() {
        const selected = [];
        optionBlocks.forEach(function (block) {
          const pills = block.querySelectorAll('.pprod-size-pill');
          const select = block.querySelector('[data-option-select]');
          if (pills.length) {
            const active = block.querySelector('.pprod-size-pill.is-active');
            const value = active ? active.getAttribute('data-option-value') : pills[0].getAttribute('data-option-value');
            selected.push(value);
          } else if (select) {
            selected.push(select.value);
          }
        });
        return selected;
      }

      function findMatchingVariant(options) {
        if (!variants || !variants.length) return null;
        return variants.find(function (v) {
          return options.every(function (opt, i) {
            return v.options[i] === opt;
          });
        });
      }

      function updateVariant() {
        const options = getCurrentOptions();
        const match = findMatchingVariant(options) || (variants && variants[0]);
        if (variantIdInput && match) {
          variantIdInput.value = match.id;
        }
      }

      optionBlocks.forEach(function (block) {
        const pills = block.querySelectorAll('.pprod-size-pill');
        const select = block.querySelector('[data-option-select]');

        if (pills.length) {
          pills.forEach(function (p) {
            p.addEventListener('click', function () {
              pills.forEach(function (x) { x.classList.remove('is-active'); });
              p.classList.add('is-active');
              updateVariant();
            });
          });
        }

        if (select) {
          select.addEventListener('change', updateVariant);
        }
      });

      updateVariant();
    });
  });
  
  } catch(e) { console.error(e); }
})();
})();
